import { Paperclip, Send, X } from "lucide-react";
import { useRef, useState } from "react";

export function ChatComposer({ disabled, onSend }) {
  const [text, setText] = useState("");
  const [files, setFiles] = useState([]);
  const [sending, setSending] = useState(false);
  const inputRef = useRef(null);

  const submit = async (event) => {
    event.preventDefault();
    if (disabled || sending || (!text.trim() && files.length === 0)) return;
    setSending(true);
    try {
      await onSend(text, files);
      setText("");
      setFiles([]);
      if (inputRef.current) inputRef.current.value = "";
    } finally {
      setSending(false);
    }
  };

  return (
    <form data-testid="chat-composer-form" onSubmit={submit} className="border-t border-[#DCD7CE] bg-white p-3">
      {files.length > 0 && (
        <div data-testid="chat-selected-files-list" className="flex flex-wrap gap-2 mb-2">
          {files.map((file, idx) => (
            <span key={`${file.name}-${idx}`} className="inline-flex items-center gap-1 rounded-full bg-[#F4F1EA] border border-[#DCD7CE] px-2 py-1 text-xs text-[#0B2230] max-w-full">
              <span className="truncate max-w-44">{file.name}</span>
              <button
                data-testid={`chat-remove-selected-file-${idx}-button`}
                type="button"
                onClick={() => setFiles((prev) => prev.filter((_, i) => i !== idx))}
                className="text-[#5C6B73] hover:text-[#991B1B]"
                aria-label="Remover arquivo"
              >
                <X className="w-3 h-3" />
              </button>
            </span>
          ))}
        </div>
      )}
      <div className="flex items-end gap-2">
        <label className="w-10 h-10 rounded-lg border border-[#DCD7CE] grid place-items-center cursor-pointer hover:bg-[#F4F1EA] transition-colors" data-testid="chat-attach-file-label">
          <Paperclip className="w-4 h-4 text-[#0B2230]" />
          <input
            data-testid="chat-attach-file-input"
            ref={inputRef}
            type="file"
            multiple
            className="hidden"
            onChange={(e) => setFiles(Array.from(e.target.files || []))}
          />
        </label>
        <textarea
          data-testid="chat-message-input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) submit(e);
          }}
          disabled={disabled || sending}
          placeholder={disabled ? "Selecione uma conversa" : "Escreva uma mensagem…"}
          className="min-h-[42px] max-h-28 flex-1 resize-none rounded-lg border border-[#DCD7CE] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#0B2230]/20 disabled:bg-[#F4F1EA]"
        />
        <button
          data-testid="chat-send-message-button"
          type="submit"
          disabled={disabled || sending || (!text.trim() && files.length === 0)}
          className="w-10 h-10 rounded-lg bg-[#0B2230] text-white grid place-items-center hover:bg-[#143346] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          aria-label="Enviar mensagem"
        >
          <Send className="w-4 h-4" />
        </button>
      </div>
    </form>
  );
}